module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Koeniz_COA-654fcc93302db7d7c5f4f79fd1d3f77c.svg";